import { useDocumentTitle } from "@/hooks/use-document-title";

function ThankYouPage() {
  useDocumentTitle("Thank You");

  return (
    <div className="mx-auto grid min-h-dvh place-items-center px-4 py-16">
      <div className="flex w-full flex-col items-center gap-6 bg-white text-center sm:max-w-[600px] sm:rounded-xl sm:p-12 sm:shadow-xl sm:ring-1 sm:ring-black/5 dark:bg-transparent dark:shadow-none dark:ring-0">
        <p className="text-muted-foreground">Thank you for your submission.</p>
      </div>
    </div>
  );
}

export { ThankYouPage };
